import { isSameYear, isToday, isYesterday } from 'date-fns'
import { TFunction } from 'i18next'

import { formatDate } from '../../../../../../../utils/date-fns'

export const formatTransactionGroupDate = (dateKey: string, t: TFunction, locale?: string): string => {
  const [year, month, day] = dateKey.split('-').map(Number)
  const date = new Date(year, month - 1, day)

  if (isToday(date)) {
    return t('today')
  }

  if (isYesterday(date)) {
    return t('yesterday')
  }

  if (isSameYear(date, new Date())) {
    return formatDate(date, 'd MMMM', locale)
  }

  return formatDate(date, 'd MMMM yyyy', locale)
}
